module.exports = __webpack_public_path__ + "img/facebook.4111bad8.png";